export default __webpack_public_path__ + "static/media/truck_half.fbce4225.svg";